import { css, styled } from '@mui/material';

export const StyledPageDetailsHeadingContainer = styled('div')(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    margin-bottom: ${theme.spacing('LARGE')};
    column-gap: ${theme.spacing('LARGE')};
  `
);

export const StyledClaimContactPersonDetail = styled('div')(
  ({ theme }) => css`
    display: flex;
    margin-top: ${theme.spacing('LARGE')};
  `
);

export const StyledClaimContactPersonInfo = styled('div')(
  ({ theme }) => css`
    ${theme.breakpoints.up('desktop')} {
      display: flex;
    }
  `
);

export const StyledContentText = styled('div')(
  ({ theme }) => css`
    margin-left: ${theme.spacing('SMALL')};

    ${theme.breakpoints.up('desktop')} {
      margin-right: ${theme.spacing('1XL')};
    }
  `
);
